
import React, { useState, useEffect } from 'react'
// import products from '../products'
import { useParams, Link, useNavigate } from 'react-router-dom'
import { Button, Col, FormControl, Image, ListGroup, ListGroupItem, Row } from 'react-bootstrap';
import Rating from '../components/Rating';

import { useDispatch, useSelector } from 'react-redux'
import { fetchProductDetails } from '../actions/productActions';

import Loader from '../components/Loader'
import Message from '../components/Message'
import { BASE_URL } from '../constants/urlConstants';

function ProductScreen() {
  const history = useNavigate()
  const { id } = useParams()
  const dispatch = useDispatch()

  const productDetails = useSelector(state => state.productDetails)
  const { error, loading, product } = productDetails

  const [qty,setQty] = useState(1)

  useEffect(() => {
    dispatch(fetchProductDetails(id))
    
  }, [dispatch,id])

  const addToCartHandler = () =>{
    history(`/cart/${id}?qty=${qty}`)
  }

  return (
    <div>
      <Link className='btn btn-light my-3' to="/">go back</Link>

      {loading ? <Loader />
        : error ? <Message variant='danger' text={error} />
          :
          (<Row>

            <Col sm={12} md={5} lg={5} xl={5}>
              <Image src={`${BASE_URL}/${product.image}`} alt={product.name} />
            </Col>
            <Col sm={12} md={7} lg={7} xl={7}>
              <Row>
                <Col sm={12} md={6} lg={6} xl={6}>
                  <ListGroup variant='flush'>
                    <ListGroupItem>
                      <h5>{product.name}</h5>
                    </ListGroupItem>

                  </ListGroup>
                </Col>
                <Col sm={12} md={6} lg={6} xl={6}>
                  <ListGroup variant='flush'>
                    {/* <ListGroupItem>
                      <Row>
                        <Col>قیمت :</Col>
                        <Col>{product.price} ریال</Col>
                      </Row>
                    </ListGroupItem>

                    <ListGroupItem>
                      <Row>
                        <Col>وضعیت :</Col>
                        <Col>{product.countInStock > 0 ? "موجود" : "ناموجود"}</Col>
                      </Row>
                    </ListGroupItem>
                    {product.countInStock > 0 && (

                      <ListGroupItem>
                        <Row>
                          <Col>تعداد :</Col>
                          <Col>
                            <FormControl as="select" value={qty} custom onChange={(e) => setQty(e.target.value)}>
                              {
                                [...Array(product.countInStock).keys()].map((x) => (
                                  <option key={x+1} value={x+1}>
                                    {x + 1}
                                  </option>
                                ))
                              }

                            </FormControl>
                          </Col>
                        </Row>
                      </ListGroupItem>

                    )}



                    <ListGroupItem>
                      <Button
                      onClick={addToCartHandler}
                       type='button' className='btn-black' disabled={product.countInStock === 0}>افزودن به سبد</Button>
                    </ListGroupItem>
 */}
                  </ListGroup>
                </Col>
              </Row>
              <Row>
                <Col>
                  <strong> توضیحات : </strong> {product.description}
                </Col>
              </Row>
            </Col>
          </Row>


          )
      }


    </div>
  )
}

export default ProductScreen
